export { matchers } from './matchers.js';

export const nodes = [() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19')];

export const server_loads = [2,4];

export const dictionary = {
	"/(app)": [5,[2],[3]],
	"/(error)/404": [19,[4]],
	"/(app)/barrierefreiheit": [6,[2],[3]],
	"/(app)/beitraeger-innen": [7,[2],[3]],
	"/(app)/briefe": [8,[2],[3]],
	"/(app)/datenschutz": [9,[2],[3]],
	"/(app)/faq": [10,[2],[3]],
	"/(app)/impressum": [11,[2],[3]],
	"/(app)/meine-beitraege": [12,[2],[3]],
	"/(app)/nutzungsbedingungen": [13,[2],[3]],
	"/(app)/object/[id]": [~14,[2],[3]],
	"/(app)/reset-password": [15,[2],[3]],
	"/(app)/transkriptionsregeln": [16,[2],[3]],
	"/(app)/user": [17,[2],[3]],
	"/(app)/verify-email": [18,[2],[3]]
};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';